import { LoadingButton } from "@mui/lab";
import { Box, Button, Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import Label from "src/components/Label";
import api from "src/services/api";
import axiosInstance from "src/utils/axios";
import { useMutationCustom } from "src/utils/reactQueryHooks";

/* eslint-disable arrow-body-style */
const ListEntezar = ({
    currentData = {},
    setWaitListStage = () => { }
}) => {

    const navigate = useNavigate();

    const admin = useSelector((store) => store.admin.data);


    const [AcceptRuleUser, setAcceptRuleUser] = useState(false)

    const handleChange = (event) => {
        setAcceptRuleUser(event.target.checked);
    };

    const cancelApi = () => axiosInstance.post(api.status.waitStatus, {}, {
        headers: {
            Authorization: `Bearer ${currentData?.token}`
        }
    });
    const cancelTravel = useMutationCustom({
        url: cancelApi,
        name: `${api.status.change.base}_add_to_wait_list`,
        onSuccess: async (resData) => {
            setWaitListStage({
                show: false,
                data: {}
            })
            toast.success(`شما در لیست انتظار قرار گرفتید`)
        },
    });

    const handleAcceptRules = () => {

        if (!AcceptRuleUser) {
            toast.error("برای قرار گرفتن در لیست انتظار باید شرایط اعزام را بپذیرید !")
            return
        }

        // const sendData = {
        //     code_melli : admin?.code_melli,
        //     phone: admin?.phone
        // }

        cancelTravel.mutate()

        // setRulesItem();
        // navigate("/")
    }

    return (
        <>
            <Stack direction={"column"} gap={1.5}>

                <Typography
                    sx={{
                        fontWeight: 700
                    }}
                >
                    <Label
                        variant={'ghost'}
                        color={"error"}
                        sx={{
                            fontSize: 15,
                            p: 3,
                            px: 1
                        }}
                    >
                        متاسفانه شما در قرعه کشی این دوره انتخاب نشده اید
                    </Label>

                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15
                    }}
                >
                    با توجه به عدم پذیرفته شدن شما در قرعه کشی عمره 1404؛ در صورت دارا بودن شرایط زیر می توانید موافقت خود را در قرار گرفتن در لیست انتظار عمره دوره جاری اعلام نمائید.
                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15
                    }}
                >
                    از آن جهت که برخی دانشگاهیان به دلایل اغلب درسی و زمانی امکان سفر را ندارند و به یکباره در بازه نزدیک زمان اعزام انصراف خود را اعلام می نمایند؛ لیست انتظار تشگیل می گردد.
                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15
                    }}
                    color={"error"}
                >
                    توجه: لیست انتظار به معنی اعزام قطعی نبوده و منوط به تعداد متقاضیان و ظرفیت خالی کاروان ها می باشد
                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15
                    }}
                >
                    لطفا با دقت مطالب زیر را مطالعه نموده و فقط در صورت دارا بودن شرایط موافقت خود را اعلام نمائید
                </Typography>

                <Typography
                    sx={{
                        fontSize: 17,
                        fontWeight: 700
                    }}
                >
                    شرایط
                </Typography>

                <Box
                    sx={{
                        pl: 1.5
                    }}
                >

                    <Typography
                        sx={{
                            lineHeight: 2,
                            fontSize: 15
                        }}
                    >
                        1- دارابودن گذرنامه با اعتبار حداقل تا پایان خرداد 1405
                    </Typography>
                    <Typography
                        sx={{
                            lineHeight: 2,
                            fontSize: 15
                        }}
                    >
                        2 - داشتن شرایط قطعی اعزام و آزاد بودن زمان برای اعزام دربازه 25  آبان 1404 لغایت 27  آذر 1404  زمان تقریبی گروه های اعزامی:

                        <br />
                        دختران مجرد دانشجو: 25 آبان لغایت 7 آذر
                        <br />
                        متاهلین و اساتید: 25 آبان لغایت 15 آذر
                        <br />
                        پسران مجرد دانشجو: 16 آذر لغایت 27 آذر
                    </Typography>
                </Box>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15,
                    }}
                >
                    نکته مهم: اعزام حدود یک هفته یا کمتر به تاریخ حرکت از طریق پیامک اطلاع رسانی گردیده و لازم است حداکثر ظرف 24تا48 ساعت نسبت به واریز هزینه سفر و تحویل مدارک اقدام گردد
                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15,
                    }}
                >
                    3-آماده بودن کل هزینه سفر جهت واریز آنی و ارسال برای اخذ ویزا
                </Typography>

                <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} mt={3}>
                    <FormControlLabel
                        control={<Checkbox color="success" onChange={handleChange} checked={AcceptRuleUser} />}
                        label="اینجانب با شرایط فوق موافق نموده و درخواست قرار گرفتن در لیست انتظار را دارم"
                        labelPlacement="end"
                    />

                    <LoadingButton
                        variant="contained"
                        color="success"
                        onClick={handleAcceptRules}
                        loading={cancelTravel.isLoading}
                    >
                        ثبت
                    </LoadingButton>

                </Stack>

            </Stack>
        </>
    );
}

export default ListEntezar;